import React from "react";
import { datadogLogs } from "@datadog/browser-logs";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

function Fallback({ error }) {
  return <p>{error.message}</p>;
}

export const notifyDatadogWithError = (error, info) => {
  datadogLogs.logger.error(
    "An error occurred in web-profile",
    {
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack ?? error?.stack ?? ""
    },
    error
  );
};

const ErrorBoundary = ({ children }) => {
  const handleError = (error, info) => {
    datadogLogs.logger.error(
      "An error occurred in web-profile",
      {
        message: error?.message,
        stack: error?.stack,
        componentStack: info?.componentStack ?? error?.stack ?? ""
      },
      error
    );
  };

  return (
    <ReactErrorBoundary FallbackComponent={Fallback} onError={handleError}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
